import GetInitialMembershipRequestRequestModel from '../../../generated/types/model/request/GetInitialMembershipRequestRequestModel';

export default class GetInitialMembershipRequestRequestViewModel extends GetInitialMembershipRequestRequestModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
